import { api } from "..";
import { DocumentRequest } from "../documentrequest/types";
import {
  AllRequestTemplateType,
  CreateDocumentRequestTemplateType,
  RequestTemplateType,
  SendRequestType,
} from "./type";

const RequestTemplateAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getAllRequestTemplates: build.query<AllRequestTemplateType[], void>({
      query: () => "/documentrequesttemplate/all",
      providesTags: ["DocumentRequestTemplate"],
    }),
    getRequestTemplateById: build.query<RequestTemplateType, { id: string }>({
      query: ({ id }) => `/documentrequesttemplate/${id}`,
      providesTags: ["DocumentRequestTemplate"],
    }),
    updateRequestTemplate: build.mutation<
      void,
      { id: string, name: string, description: string }
    >({
      query: ({ id, ...body }) => {
        return {
          url: `documentrequesttemplate/${id}`,
          method: "PUT",
          body: body,
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
    addDocRequestTemplate: build.mutation<
      void,
      { id: string; documentRequest: DocumentRequest }
    >({
      query: ({ id, documentRequest }) => {
        return {
          url: `documentrequesttemplate/${id}/docrequest`,
          method: "PUT",
          body: documentRequest,
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
    deleteRequestTemplate: build.mutation<void, { id: string }>({
      query: ({ id }) => {
        return {
          url: `documentrequesttemplate/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
    saveRequestTemplate: build.mutation<void, { name: string, description: string }>({
      query: ({ ...body }) => {
        return {
          url: `documentrequesttemplate`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
    sendRequestTemplate: build.mutation<void, SendRequestType>({
      query: ({ ...body }) => {
        return {
          url: `documentrequesttemplate/send`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
    deleteDocumentShareRequestTemplate: build.mutation<void, { id: string, documentShareRequestId: string }>({
      query: ({ id, documentShareRequestId }) => {
        return {
          url: `documentrequesttemplate/${id}/documentsharerequest/${documentShareRequestId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["DocumentRequestTemplate"],
    }),
  }),
});
export const {
  useGetAllRequestTemplatesQuery,
  useGetRequestTemplateByIdQuery,
  useUpdateRequestTemplateMutation,
  useSaveRequestTemplateMutation,
  useAddDocRequestTemplateMutation,
  useSendRequestTemplateMutation,
  useDeleteRequestTemplateMutation,
  useDeleteDocumentShareRequestTemplateMutation
} = RequestTemplateAPI;
